'use client';

import {
  FeatherAlertTriangle,
  FeatherCheckCircle,
  FeatherClock,
  FeatherXCircle,
} from '@subframe/core';

import { Badge } from './Badge';

export type EntregaInfo =
  | { kind: 'vazio' }
  | { kind: 'aguardandoValidacao' }
  | { kind: 'aguardando' }
  | { kind: 'encerrado'; entregues: number; total: number }
  | { kind: 'parcial'; entregues: number; total: number }
  | { kind: 'completo'; entregues: number; total: number };

export function EntregaCell({ info }: { info: EntregaInfo }) {
  switch (info.kind) {
    case 'aguardandoValidacao':
      return (
        <Badge
          variant="neutral"
          icon={<FeatherClock className="h-3.5 w-3.5" />}
          className="border-neutral-200"
        >
          Aguardando validação
        </Badge>
      );
    case 'aguardando':
      return (
        <Badge
          variant="neutral"
          icon={<FeatherClock className="h-3.5 w-3.5" />}
          className="border-neutral-200"
        >
          Aguardando disparo
        </Badge>
      );
    case 'completo':
      return (
        <Badge
          variant="success"
          icon={<FeatherCheckCircle className="h-3.5 w-3.5" />}
          className="border-success-200 bg-success-50"
        >
          {info.entregues}/{info.total}
        </Badge>
      );
    case 'parcial':
      return (
        <Badge
          variant="warning"
          icon={<FeatherAlertTriangle className="h-3.5 w-3.5" />}
          className="border-warning-200 bg-warning-50"
        >
          {info.entregues}/{info.total}
        </Badge>
      );
    case 'encerrado':
      return (
        <Badge
          variant="neutral"
          icon={<FeatherXCircle className="h-3.5 w-3.5" />}
          className="border-neutral-200"
        >
          {info.entregues}/{info.total}
        </Badge>
      );
    case 'vazio':
    default:
      return <span className="text-body font-body text-subtext-color">—</span>;
  }
}
